<template>
  <div v-if="searchResultStore.searchResultState.status === 'success'">
    <TsSearchResults
      :headerContent="hideTitle === true ? '' : brandStore.brandSlug"
      search-type="brand-search"
      :show-filters="props.showFilters"
    ></TsSearchResults>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'failed'">
    <TsNoResultFound></TsNoResultFound>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'loading'">
    <TsSearchPageLoading
      :search-query="algoliaStore.currentActiveBrand"
    ></TsSearchPageLoading>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'idle'">
    <TsSearchPageLoading
      :search-query="algoliaStore.currentActiveBrand"
    ></TsSearchPageLoading>
  </div>
</template>

<script setup lang="ts">
const TsSearchResults = defineAsyncComponent(
    () => import('~/components/organisms/TsSearchResults.vue')
);

const TsNoResultFound = defineAsyncComponent(
    () => import('~/components/organisms/TsNoResultFound.vue')
);

const TsSearchPageLoading = defineAsyncComponent(
    () => import('~/components/organisms/TsSearchPageLoading.vue')
);
const nuxtApp = useNuxtApp();
const config = useRuntimeConfig();
const {locale} = useI18n();
const route = useRoute();
const {isMobile,isDesktop} = useDevice()
const algoliaStore = useAlgoliaStore();
const brandStore = useBrandStore();
if (!algoliaStore.currentActiveBrand && route.params.brandName) {
  algoliaStore.currentActiveBrand = route.params.brandName;
}

const searchResultStore = useSearchResultStore();
type Props = {
  title?: string;
  hideTitle?: boolean;
  showFilters?: boolean;
  dealsProperties?: object | null;
};

const props = withDefaults(defineProps<Props>(), {
  showFilters: true,
  dealsProperties: null,
});
// searchResultStore.productState.status = "loading";


setMetaTags();
// await onLoad();
// await fetchStockOfProduct();

// Create a computed property that combines the query and the trigger
const watchedQuery = computed(() => ({
  query: route.query,
  trigger: searchResultStore.isWatchTrigger,
}))

const { data: productList } = await useLazyAsyncData(`brand-search-${route.params.brandName}`, async () =>{
 
 return searchResultStore.onLoadPlp(route, "brand-search", props.dealsProperties,locale.value,isMobile,isDesktop,config,nuxtApp)
}, {
    dedupe: "cancel",
})

const { data: stock } = await useAsyncData(`category-plp-stock-${route.params.brandName}`,
   async () => {
     if(productList.value){
       return searchResultStore.fetchStockOfProduct(nuxtApp,config)
     }
     return false;
   },{
     lazy:true,
     dedupe: "cancel",
     watch:[productList]
   })

const stopWatcher = watch(
  watchedQuery,
  async (newQuery, oldQuery) => {
    const layoutChanged = oldQuery.layout !== newQuery.layout;
    // Check if any other property has changed
    const otherQueriesChanged = Object.keys(newQuery).some(
      (key) => key !== "layout" && newQuery[key] !== oldQuery[key]
    );

    // If only the layout has changed, return
    if (layoutChanged && !otherQueriesChanged) {
      return;
    }
    setMetaTags();

    await searchResultStore.onLoadPlp(route, "brand-search",null,locale.value,isMobile,isDesktop,config,nuxtApp);
    await searchResultStore.fetchStockOfProduct();
  }
);

onUnmounted(() => {
  stopWatcher();
});

function setMetaTags() {
  useHead({
    title: `Toolstation | Brand - "${useCapitalize(
      getSearchQueryFromRoute().replaceAll("-", " ")
    )}"`,
    meta: [
      {
        name: "description",
        content: `Product listing page for ${getSearchQueryFromRoute()}`,
      },
    ],
  });
}

function getSearchQueryFromRoute() {
  return (route.params.brandName as string) || algoliaStore.currentActiveBrand;
}

</script>
